module.exports = __webpack_public_path__ + "img/lg_ring_r_s_0_0@2x.7670daea.png";